import { Suspense } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "reactstrap";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { unwrapAsset } from "../../utils/CockpitUtils";
import Herobox from "../Herobox";
import Icon from "../Icon";
import GenericSlideThumb from "./SlideThumb";
import { useStoryById } from "../../hooks/CmsHooks";
import SimpleLoadingSpinner from "../SimpleLoadingSpinner";
import classNames from "classnames";
import GenericSlideTab from "./SlideTab";

const StorySlide = props => {
  const { story, className, deferLoading, ...rest } = props;
  return (
    <Suspense
      fallback={
        <Herobox
          className={classNames(className, "loading")}
          theme="black"
          type="fat"
          centerImage
          textShadow
        >
          <SimpleLoadingSpinner />
        </Herobox>
      }
    >
      <StorySlideInner
        {...rest}
        story={story}
        className={className}
        deferLoading={deferLoading}
      />
    </Suspense>
  );
};

const StorySlideInner = ({
  story: _story,
  className,
  deferLoading = false,
  ...rest
}) => {
  const t = useBjelinTranslations();
  const story = useStoryById(_story._id);
  //console.log("story", story);
  if (!story?._id) return null;

  if (story) {
    return (
      <Herobox
        {...rest}
        className={className}
        mode="storytelling"
        theme="black"
        type="fat"
        backgroundImage={unwrapAsset(story.featured_image)}
        textShadow
        deferLoading={deferLoading}
        ariaLabel={story.title}
      >
        <div className="cockpit-bjelin_heading text-center">
          <h2>{story.title}</h2>
        </div>
        <div className="cockpit-bjelin_button text-center">
          <Link className={"button-outlined"} to={"/stories/" + story.path}>
            {t("read.story")} <Icon name="chevron-right" />
          </Link>
        </div>
      </Herobox>
    );
  }
  return null;
};

export const StorySlideThumb = ({ id, isActive, onClick }) => {
  return (
    <Suspense
      fallback={
        <div className="slide-thumb">
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#333",
              color: "#fff"
            }}
          >
            <Spinner />
          </div>
        </div>
      }
    >
      <StorySlideThumbInner id={id} isActive={isActive} onClick={onClick} />
    </Suspense>
  );
};

const StorySlideThumbInner = ({ id, isActive, onClick }) => {
  const story = useStoryById(id);
  if (!story?._id) return null;

  const fImage = unwrapAsset(story.featured_image);
  const image = fImage.styles ? fImage.styles.px828 : fImage.path;
  const label = story.title;
  if (story) {
    return (
      <GenericSlideThumb
        image={image}
        label={label}
        isActive={isActive}
        onClick={onClick}
      />
    );
  }
  return null;
};

export const StorySlideTab = ({ id, isActive, onClick }) => {
  return (
    <Suspense
      fallback={
        <div className="slide-tab">
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#333",
              color: "#fff"
            }}
          >
            <Spinner />
          </div>
        </div>
      }
    >
      <StorySlideTabInner id={id} isActive={isActive} onClick={onClick} />
    </Suspense>
  );
};

const StorySlideTabInner = ({ id, isActive, onClick }) => {
  const story = useStoryById(id);
  if (!story?._id) return null;

  const fImage = unwrapAsset(story.featured_image);
  const image = fImage.styles ? fImage.styles.px828 : fImage.path;
  const label = story.title;
  if (story) {
    return (
      <GenericSlideTab
        image={image}
        label={label}
        isActive={isActive}
        onClick={onClick}
      />
    );
  }
  return null;
};

export default StorySlide;
